module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-bg.96411f8d.png";